<template>
  <div>
    <div v-show="showClick2PayPaymentIframe" class="c2p-wrapper with-c2p-iframe">
      <div class="click2payIframeWrapper">
        <iframe ref="click2payIframe" id="click2payIframe"></iframe>
      </div>
    </div>
    <form v-show="!showClick2PayPaymentIframe" ref="form" @submit.prevent="submit" v-form:form novalidate>
      <input type="hidden"
             id="paywayID"
             name="paywayID"
             :label="$t('paywall.form.payway.label')"
             v-model="paywayID"
             requiredPayway/>

      <!-- kanały płatności -->
      <fieldset ref="paywayElem" class="form-row" v-if="canShowPaywayList()"
                :class="{'is-error': showTouchedError('paywayID') || isErrorForField('paywayID')}"
                :aria-invalid="getAriaInvalid('paywayID')"
                :aria-describedby="getAriaDescribedBy('paywayID')">
        <legend class="choose-bank sr-only">{{ $t('paywall.form.payway.label') }}</legend>
        <p role="alert" v-if="showTouchedError('paywayID') || isErrorForField('paywayID')" class="error"
           :id="getErrorId('paywayID')"
           :aria-label="getFieldErrorAriaLabel('paywayID', $t('paywall.form.payway.flowLabel'))">
          <span aria-hidden="true">{{ getFieldErrorText('paywayID') }}</span>
        </p>
        <payment-payway-list :payways="paywayGroup.payways"/>
      </fieldset>

      <!-- BLIK 0 -->
      <div v-if="isBlikAutoGroup">
        <div class="form-row">
          <div class="blikAutoDescription">
            <p>{{ $t('paywall.paywayGroup.blikAuto.bankList') }}</p>
            <div class="bank-list">
              <img src="/web/img/blikAuto/icon-pko.svg" alt="PKO">
              <img src="/web/img/blikAuto/icon-sgb.svg" alt="SGB">
              <img src="/web/img/blikAuto/icon-millenium.svg" alt="MILLENIUM">
              <img src="/web/img/blikAuto/icon-erste.svg" alt="ERSTE">
              <img src="/web/img/blikAuto/icon-ing.svg" alt="ING">
              <img src="/web/img/blikAuto/icon-alior.svg" alt="ALIOR">
              <img src="/web/img/blikAuto/icon-nest.svg" alt="NEST">
              <img src="/web/img/blikAuto/icon-ca.svg" alt="CA">
            </div>
          </div>
        </div>
        <div class="form-row input-text-field"
             :class="{'is-error': showTouchedError('blikCode') || isErrorForField('blikCode')}">
          <label for="blikCode">{{ $t('paywall.form.blikCode.label') }}</label>
          <div class="input-text-wrapper blikCode"
               :class="{'is-error': showTouchedError('blikCode') || isErrorForField('blikCode')}">
            <input
              type="text"
              name="blikCode"
              id="blikCode"
              v-mask="'### ###'"
              required
              blikCode
              @keydown.13.prevent
              v-model.trim="blikCode"
              :aria-invalid="getAriaInvalid('blikCode')"
              :aria-describedby="getAriaDescribedBy('blikCode')"
              :class="{ 'filled': blikCode }"/>
            <span class="input-flow-label" aria-hidden="true">&nbsp;{{
                $t('paywall.form.blikCode.flowLabel') || $t('paywall.form.blikCode.label')
              }}<span class="required">*</span>&nbsp;</span>
          </div>
          <p role="alert" v-if="showTouchedError('blikCode') || isErrorForField('blikCode')" class="error"
             :id="getErrorId('blikCode')"
             :aria-label="getFieldErrorAriaLabel('blikCode', $t('paywall.form.blikCode.flowLabel'))">
            <span aria-hidden="true">{{ getFieldErrorText('blikCode') }}</span>
          </p>
        </div>
        <div class="form-row" v-if="activePayway">
          <div class="blikAutoDescription">
            <p v-if="isBlikModel0">{{ $t('paywall.paywayGroup.blikAuto.infoModel0') }}</p>
            <p v-if="isBlikModelM">{{ $t('paywall.paywayGroup.blikAuto.infoModelM') }}</p>
          </div>
        </div>
      </div>

      <div v-if="isBlikPayLaterGroup">
        <div class="form-row">
          <div class="blikPayLaterDescription">
            <p>{{ $t('paywall.paywayGroup.blikPayLater.text1') }}</p>
            <p>{{ $t('paywall.paywayGroup.blikPayLater.text2') }}</p>
            <div class="bank-list">
              <img src="/web/img/blikPayLater/pko.svg" alt="PKO BP"/>
              <img src="/web/img/blikPayLater/velo.svg" alt="Velo Bank"/>
              <img src="/web/img/blikPayLater/millenium.svg" alt="Millenium"/>
              <img src="/web/img/blikPayLater/sgb.svg" alt="SGB"/>
            </div>
          </div>
        </div>
      </div>

      <!-- OTP -->
      <div class="form-row" v-if="isOtp">
        <div class="paykaLink" id="paykaHelp" v-if="isOtpPaykaSelected">
          <span v-if="isServiceTypeMwf">{{ $t('configuration.paywayGroups.otp.descriptionInfo1Mwf') }}</span>
          <span v-if="isServiceTypeEcommerce">{{
              $t('configuration.paywayGroups.otp.descriptionInfo1Ecommerce')
            }}</span> <a href="" @click.prevent="showPaykaModal($event)">
          <span v-if="isServiceTypeMwf">{{ $t('configuration.paywayGroups.otp.descriptionInfo2Mwf') }}</span>
          <span v-if="isServiceTypeEcommerce">{{
              $t('configuration.paywayGroups.otp.descriptionInfo2Ecommerce')
            }}</span>
        </a>
        </div>
      </div>

      <!-- Alior Raty -->
      <div class="form-row" v-if="isInstallments">
        <div class="aliorLink" id="aliorHelp" v-if="isInstallmentsSelected">
          {{ $t('configuration.paywayGroups.alior.descriptionInfo1') }}
          <!--          <a href="" @click.prevent="showAliorModal($event)">{{-->
          <!--              $t('configuration.paywayGroups.alior.descriptionInfo2')-->
          <!--            }}</a>-->
        </div>
      </div>

      <!-- Rekurencja -->
      <div class="form-row" v-if="isAutoCard && canShowCardsIframe"
           :class="{'is-error': showTouchedError('creditCard') || isErrorForField('creditCard')}">
        <input type="hidden"
               id="creditCard"
               name="creditCard"
               :label="$t('paywall.form.card.iframe.title')"
               v-model="creditCard"
               requiredCreditCard/>
        <div class="loading-mask" v-if="!iframeLoaded">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
          </svg>
        </div>
        <p aria-hidden="true" v-if="showTouchedError('creditCard') || isErrorForField('creditCard')" class="error"
           :id="getErrorId('creditCard')"
           :aria-label="getFieldErrorAriaLabel('creditCard', $t('paywall.form.card.flowLabel'))">
          <span aria-hidden="true">{{ getFieldErrorText('creditCard') }}</span>
        </p>
        <iframe ref="iframe"
                :class="{'hidden': isCardIframeHidden}"
                id="iframeCards"
                :src="getCardIframeSrc()"
                @load="setCardIframeLoaded"
                :title="$t('paywall.form.card.iframe.title')">
        </iframe>
      </div>

      <!-- karty -->
      <div class="c2p-wrapper" v-if="isCard && canShowCardsIframe">
        <div class="c2p-loading" v-if="isClick2PayLoading">
          <img src="/web/img/click2pay/loader.gif" alt="Loading">
          <div v-html="$t('paywall.form.click2pay.loaderText')"></div>
        </div>
        <div v-if="!isClick2PayLoading">
          <div v-if="isClick2PayAvailable">
            <click-to-pay-profile v-if="canShowClick2PayProfileInfo"/>
            <click-to-pay-login-form v-if="isClick2PayViewLoginForm"
                                     @resetCardWidget="resetCardWidget"
                                     @resetForm="resetForm"/>
            <click-to-pay-code-form v-if="isClick2PayViewCodeForm"/>
            <click-to-pay-card-selected v-if="isClick2PayViewCardSelected"/>
            <click-to-pay-card-select v-if="isClick2PayViewCardSelect"/>
            <click-to-pay-new-user v-if="isClick2PayViewNewUser"
                                   @cancelClick2PayProcess="cancelClick2PayProcess"
                                   @customerFormSubmited="submitClick2PayCheckout"/>
          </div>
          <div class="form-row" :class="{'is-error': showTouchedError('creditCard') || isErrorForField('creditCard')}">
            <input type="hidden"
                   id="creditCard"
                   name="creditCard"
                   :label="$t('paywall.form.card.iframe.title')"
                   v-model="creditCard"
                   requiredCreditCard/>
            <div class="loading-mask" v-if="!iframeLoaded">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
              </svg>
            </div>
            <p aria-hidden="true" v-if="showTouchedError('creditCard') || isErrorForField('creditCard')" class="error"
               :id="getErrorId('creditCard')"
               :aria-label="getFieldErrorAriaLabel('creditCard', $t('paywall.form.card.flowLabel'))">
              <span aria-hidden="true">{{ getFieldErrorText('creditCard') }}</span>
            </p>
            <iframe ref="iframe"
                    :class="{'hidden': isCardIframeHidden}"
                    id="iframeCards"
                    :src="getCardIframeSrc()"
                    @load="setCardIframeLoaded"
                    :title="$t('paywall.form.card.iframe.title')">
            </iframe>
          </div>
          <div v-if="isClick2PayAvailable && (isClick2PayViewNotRecognized || isClick2PayViewNewCard)">
            <div class="agreements"
                 v-if="(isCreditCardMastercard && isClick2PayMastercardAvailable) || (isCreditCardVisa && isClick2PayVisaAvailable)">
              <div>
                <img v-if="isCreditCardMastercard" src="/web/img/click2pay/mastercard.svg" alt="" height="20">
                <img v-if="isCreditCardVisa" src="/web/img/click2pay/visa.svg" alt="" height="20">
              </div>
              <div class="form-row">
                <input type="checkbox"
                       id="saveCard"
                       name="saveCard"
                       @keydown.13.prevent
                       v-model="c2p.saveCard"/>
                <label for="saveCard">
                  <span>
                    {{ $t('paywall.form.click2pay.saveCard.text1') }}
                    <br><span><span v-if="isCreditCardMastercard"
                                    v-html="$t('paywall.form.click2pay.saveCard.text2mc')"></span><span
                    v-if="isCreditCardVisa" v-html="$t('paywall.form.click2pay.saveCard.text2visa')"></span></span>
                    <br><a href="" @click.stop.prevent="showClick2PayModal"
                           id="click2payHelp">{{ $t('paywall.form.click2pay.saveCard.link') }}</a>
                </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- visa mobile -->
      <div class="form-row" v-if="isVisaMobile"
           :class="{'is-error': showTouchedError('visaMobile') || isErrorForField('visaMobile')}">
        <input type="hidden" id="visaMobile" name="visaMobile" v-model="visaMobile" requiredVisaMobile/>
        <div class="loading-mask" v-if="!iframeLoaded">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
          </svg>
        </div>
        <p role="alert" v-if="showTouchedError('visaMobile') || isErrorForField('visaMobile')" class="error"
           :id="getErrorId('visaMobile')"
           :aria-label="getFieldErrorAriaLabel('visaMobile', $t('paywall.form.visaMobile.flowLabel'))">
          <span aria-hidden="true">{{ getFieldErrorText('visaMobile') }}</span>
        </p>
        <iframe ref="iframe"
                id="iframeVisaMobile"
                :src="getVisaMobileIframeSrc()"
                @load="setVisaMobileIframeLoaded"
                :title="$t('paywall.form.visaMobile.iframe.title')">
        </iframe>
      </div>

      <!-- email -->
      <div class="form-row input-text-field" v-if="showEmail && !isClick2PayOnlyView"
           :class="{'is-error': showTouchedError('customerEmail') || isErrorForField('customerEmail')}">
        <label for="customerEmail" v-if="!isClick2PayProcessActive && !c2p.saveCard">{{
            $t('paywall.form.email.label')
          }}</label>
        <label for="customerEmail" v-if="isClick2PayProcessActive || c2p.saveCard">{{
            $t('paywall.form.click2pay.email.labelForClick2Pay')
          }}</label>
        <div class="input-text-wrapper"
             :class="{'is-error': showTouchedError('customerEmail') || isErrorForField('customerEmail')}">
          <input
            type="email"
            name="customerEmail"
            id="customerEmail"
            email
            required
            @keydown.13.prevent
            @blur="onEmailBlur"
            v-model.trim="customerEmail"
            :aria-invalid="getAriaInvalid('customerEmail')"
            :aria-describedby="getAriaDescribedBy('customerEmail')"
            :class="{ 'filled': customerEmail }"/>
          <span class="input-flow-label"
                aria-hidden="true">&nbsp;{{ $t('paywall.form.email.flowLabel') || $t('paywall.form.email.label') }}<span
            class="required">*</span>&nbsp;</span>
        </div>
        <p role="alert" v-if="showTouchedError('customerEmail') || isErrorForField('customerEmail')"
           class="error"
           :id="getErrorId('customerEmail')"
           :aria-label="getFieldErrorAriaLabel('customerEmail', $t('paywall.form.email.flowLabel'))">
          <span aria-hidden="true">{{ getFieldErrorText('customerEmail') }}</span>
        </p>
        <div class="email-info" v-if="!isInitialCustomerEmailSet">
          <p>{{ $t('paywall.form.email.tip') }}</p>
        </div>
        <div class="email-info" v-if="showEmailFuseInfo">
          <p>{{ $t('paywall.form.email.fuse') }}</p>
        </div>
      </div>

      <!-- dodatkowe wymagane pola generowane dynamicznie -->
      <div v-if="hasPaywayRequiredFields">
        <!-- najpierw niezgrupowane -->
        <div v-for="(field, index1) in paywayRequiredParamsList['ungrupped']" :key="index1">
          <div v-if="isRequiredParamFieldTypeText(field.type)" class="form-row input-text-field"
               :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
            <label :for="field.name">{{ getRequiredParamLabel(field.name) }}</label>
            <div class="input-text-wrapper"
                 :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
              <input
                :type="getRequiredParamFieldType(field.type)"
                :name="field.name"
                :id="field.name"
                :pattern="field.pattern"
                :required="field.required"
                @keydown.13.prevent
                v-model.trim="requiredParams[field.name]"
                :aria-invalid="getAriaInvalid(field.name)"
                :aria-describedby="getAriaDescribedBy(field.name)"
                :class="{ 'filled': requiredParams[field.name] }"
              />
              <span class="input-flow-label" aria-hidden="true">&nbsp;{{
                  getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name)
                }}<span v-if="field.required" class="required">*</span>&nbsp;</span>
            </div>
            <p role="alert" v-if="showTouchedError(field.name) || isErrorForField(field.name)" class="error"
               :id="getErrorId(field.name)"
               :aria-label="getFieldErrorAriaLabel(field.name, getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name))">
              <span aria-hidden="true">{{ getFieldErrorText(field.name) }}</span>
            </p>
          </div>
          <div v-if="isRequiredParamFieldTypeCheckbox(field.type)" class="agreements">
            <div class="form-row" :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
              <input type="checkbox"
                     :id="field.name"
                     :name="field.name"
                     @keydown.13.prevent
                     v-model="requiredParams[field.name]"
                     :required="field.required"
              />
              <label :for="field.name">
                <span v-if="showTouchedError(field.name) || isErrorForField(field.name)" class="error">
                  {{ getFieldErrorText(field.name) }}
                </span>
                <span>
                  <span class="required">* </span>
                  <span>{{ getRequiredParamLabel(field.name) }}</span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- name -->
        <div v-if="paywayRequiredParamsList['name']" class="required-field-group group-name">
          <div v-for="(field, index2) in paywayRequiredParamsList['name']" :key="index2">
            <div v-if="isRequiredParamFieldTypeText(field.type)">
              <div class="form-row input-text-field"
                   :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
                <label :for="field.name">{{ getRequiredParamLabel(field.name) }}</label>
                <div class="input-text-wrapper"
                     :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
                  <input
                    :type="getRequiredParamFieldType(field.type)"
                    :name="field.name"
                    :id="field.name"
                    :pattern="field.pattern"
                    :required="field.required"
                    @keydown.13.prevent
                    v-model.trim="requiredParams[field.name]"
                    :aria-invalid="getAriaInvalid(field.name)"
                    :aria-describedby="getAriaDescribedBy(field.name)"
                    :class="{ 'filled': requiredParams[field.name] }"
                  />
                  <span class="input-flow-label" aria-hidden="true">&nbsp;{{
                      getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name)
                    }}<span v-if="field.required" class="required">*</span>&nbsp;</span>
                </div>
                <p role="alert" v-if="showTouchedError(field.name) || isErrorForField(field.name)" class="error"
                   :id="getErrorId(field.name)"
                   :aria-label="getFieldErrorAriaLabel(field.name, getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name))">
                  <span aria-hidden="true">{{ getFieldErrorText(field.name) }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- address1 -->
        <div v-if="paywayRequiredParamsList['address1']" class="required-field-group group-address1">
          <div v-for="(field, index3) in paywayRequiredParamsList['address1']" :key="index3">
            <div v-if="isRequiredParamFieldTypeText(field.type)" class="form-row input-text-field"
                 :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
              <label :for="field.name">{{ getRequiredParamLabel(field.name) }}</label>
              <div class="input-text-wrapper"
                   :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
                <input
                  :type="getRequiredParamFieldType(field.type)"
                  :name="field.name"
                  :id="field.name"
                  :pattern="field.pattern"
                  :required="field.required"
                  @keydown.13.prevent
                  v-model.trim="requiredParams[field.name]"
                  :aria-invalid="getAriaInvalid(field.name)"
                  :aria-describedby="getAriaDescribedBy(field.name)"
                  :class="{ 'filled': requiredParams[field.name] }"
                />
                <span class="input-flow-label" aria-hidden="true">&nbsp;{{
                    getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name)
                  }}<span v-if="field.required" class="required">*</span>&nbsp;</span>
              </div>
              <p role="alert" v-if="showTouchedError(field.name) || isErrorForField(field.name)" class="error"
                 :id="getErrorId(field.name)"
                 :aria-label="getFieldErrorAriaLabel(field.name, getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name))">
                <span aria-hidden="true">{{ getFieldErrorText(field.name) }}</span>
              </p>
            </div>
          </div>
        </div>

        <!-- address2 -->
        <div v-if="paywayRequiredParamsList['address2']" class="required-field-group group-address2">
          <div v-for="(field, index4) in paywayRequiredParamsList['address2']" :key="index4">
            <div v-if="isRequiredParamFieldTypeText(field.type)" class="form-row input-text-field"
                 :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
              <label :for="field.name">{{ getRequiredParamLabel(field.name) }}</label>
              <div class="input-text-wrapper"
                   :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
                <input
                  :type="getRequiredParamFieldType(field.type)"
                  :name="field.name"
                  :id="field.name"
                  :pattern="field.pattern"
                  :required="field.required"
                  @keydown.13.prevent
                  v-model.trim="requiredParams[field.name]"
                  :aria-invalid="getAriaInvalid(field.name)"
                  :aria-describedby="getAriaDescribedBy(field.name)"
                  :class="{ 'filled': requiredParams[field.name] }"
                />
                <span class="input-flow-label" aria-hidden="true">&nbsp;{{
                    getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name)
                  }}<span v-if="field.required" class="required">*</span>&nbsp;</span>
              </div>
              <p role="alert" v-if="showTouchedError(field.name) || isErrorForField(field.name)" class="error"
                 :id="getErrorId(field.name)"
                 :aria-label="getFieldErrorAriaLabel(field.name, getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name))">
                <span aria-hidden="true">{{ getFieldErrorText(field.name) }}</span>
              </p>
            </div>
          </div>
        </div>

        <!-- address3 -->
        <div v-if="paywayRequiredParamsList['address3']" class="required-field-group group-address3">
          <div v-for="(field, index4) in paywayRequiredParamsList['address3']" :key="index4">
            <div v-if="isRequiredParamFieldTypeText(field.type)" class="form-row input-text-field"
                 :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
              <label :for="field.name">{{ getRequiredParamLabel(field.name) }}</label>
              <div class="input-text-wrapper"
                   :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
                <input
                  :type="getRequiredParamFieldType(field.type)"
                  :name="field.name"
                  :id="field.name"
                  :pattern="field.pattern"
                  :required="field.required"
                  @keydown.13.prevent
                  v-model.trim="requiredParams[field.name]"
                  :aria-invalid="getAriaInvalid(field.name)"
                  :aria-describedby="getAriaDescribedBy(field.name)"
                  :class="{ 'filled': requiredParams[field.name] }"
                />
                <span class="input-flow-label" aria-hidden="true">&nbsp;{{
                    getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name)
                  }}<span v-if="field.required" class="required">*</span>&nbsp;</span>
              </div>
              <p role="alert" v-if="showTouchedError(field.name) || isErrorForField(field.name)" class="error"
                 :id="getErrorId(field.name)"
                 :aria-label="getFieldErrorAriaLabel(field.name, getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name))">
                <span aria-hidden="true">{{ getFieldErrorText(field.name) }}</span>
              </p>
            </div>
          </div>
        </div>

        <!-- address4 -->
        <div v-if="paywayRequiredParamsList['address4']">
          <div v-for="(field, index4) in paywayRequiredParamsList['address4']" :key="index4">
            <div v-if="isRequiredParamFieldTypeText(field.type)" class="form-row input-text-field"
                 :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
              <label :for="field.name">{{ getRequiredParamLabel(field.name) }}</label>
              <div v-if="field.name === 'shippingCountryCode'" class="select-wrapper country">
                <select :name="field.name"
                        :id="field.name"
                        :required="field.required"
                        v-model="requiredParams[field.name]"
                        @input.stop>
                  <option value="" disabled selected hidden>- {{ getRequiredParamPlaceholder(field.name) }} -</option>
                  <option v-for="(country, index) in paypalCountryCodes" :key="index" :value="country.code">
                    {{ getPaypalCountryName(country) }}
                  </option>
                </select>
              </div>
              <div v-else class="input-text-wrapper"
                   :class="{'is-error': showTouchedError(field.name) || isErrorForField(field.name)}">
                <input
                  :type="getRequiredParamFieldType(field.type)"
                  :name="field.name"
                  :id="field.name"
                  :pattern="field.pattern"
                  :required="field.required"
                  @keydown.13.prevent
                  v-model.trim="requiredParams[field.name]"
                  :aria-invalid="getAriaInvalid(field.name)"
                  :aria-describedby="getAriaDescribedBy(field.name)"
                  :class="{ 'filled': requiredParams[field.name] }"
                />
                <span class="input-flow-label" aria-hidden="true">&nbsp;{{
                    getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name)
                  }}<span v-if="field.required" class="required">*</span>&nbsp;</span>
              </div>
              <p role="alert" v-if="showTouchedError(field.name) || isErrorForField(field.name)" class="error"
                 :id="getErrorId(field.name)"
                 :aria-label="getFieldErrorAriaLabel(field.name, getRequiredParamFlowLabel(field.name) || getRequiredParamLabel(field.name))">
                <span aria-hidden="true">{{ getFieldErrorText(field.name) }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- zgody i oświadczenia -->
      <h3 v-if="canShowAgreementHeader && !isClick2PayOnlyView">{{ $t('paywall.form.terms.header') }}</h3>
      <div class="agreements" v-if="!isClick2PayOnlyView">
        <!-- zaznacz wszystkie -->
        <div class="form-row select-all" v-if="canShowCheckAll">
          <input type="checkbox" id="checkAll" name="checkAll" @keydown.13.prevent v-model="checkAll"
                 :model-standalone="true"/>
          <label for="checkAll" class="bold">
            {{ $t('paywall.form.terms.selectAll') }}
          </label>
        </div>

        <!-- regulamin jako checkbox -->
        <div v-if="regulation && !isRegulationHidden">
          <div class="form-row agreement-row"
               :class="{'is-error': showTouchedError('regulationApproved') || isErrorForField('regulationApproved')}">
            <div class="agreement-control">
              <input type="checkbox"
                     id="regulationApproved"
                     name="regulationApproved"
                     @keydown.13.prevent
                     v-model="regulationApproved"
                     :aria-invalid="getAriaInvalid('regulationApproved')"
                     aria-labelledby="regulationApproved_label"
                     :aria-describedby="getAriaDescribedBy('regulationApproved')"
                     requiredTerms/>
              <div class="agreement-content">
                <span id="regulationApproved_label" class="agreement-label"
                      @click="toggleRegulationByContentClick($event)">
                  <span>
                    <span class="required">* </span>
                    <regulation-text v-if="isRegulationLabelSet(regulation)" :regulation="regulation"></regulation-text>
                    <!-- TODO: określić co w przypadku jeśli regulamin nie ma labela -->
                    <span v-if="!isRegulationLabelSet(regulation)"
                          v-html="$t('paywall.form.termsLabelDefault', {regulationUrl: regulation.url, privacyPolicyUrl: privacyPolicyUrl})"></span>
                  </span>
                </span>
              </div>
            </div>
            <p role="alert" v-if="showTouchedError('regulationApproved') || isErrorForField('regulationApproved')"
               class="error"
               :id="getErrorId('regulationApproved')"
               :aria-label="getFieldErrorAriaLabel('regulationApproved', $t('paywall.form.termsFlowLabel'))">
              <span aria-hidden="true">{{ getFieldErrorText('regulationApproved') }}</span>
            </p>
          </div>
        </div>

        <!-- zgoda marketingowa - BluePersona -->
        <div v-if="canShowMarketingAgreementList">
          <div class="form-row agreement-row"
               v-for="agreement in marketingAgreementList"
               :key="agreement.code"
               :class="{'is-error': showTouchedError(agreement.code) || isErrorForField(agreement.code)}">
            <div class="agreement-control">
              <input type="checkbox"
                     :id="agreement.code"
                     :name="agreement.code"
                     @keydown.13.prevent
                     v-model="marketing[agreement.code]"
                     :aria-invalid="getAriaInvalid(agreement.code)"
                     :aria-labelledby="agreement.code + '_label'"
                     :aria-describedby="getAriaDescribedBy(agreement.code)"
                     :requiredConsent="agreement.required"/>
              <div class="agreement-content">
                <span class="agreement-label">
                  <span :id="agreement.code + '_label'" @click="toggleAgreementByContentClick(agreement, $event)">
                    <span v-if="agreement.required" class="required">* </span>
                    <span v-if="!showMore[agreement.code]">{{ getAgreementShortText(agreement.content) }}</span>
                    <span v-if="showMore[agreement.code]" :id="agreement.code + '_content'" v-html="agreement.content"></span>
                  </span>
                </span>&nbsp;
                <a class="show-more"
                   href=""
                   v-if="!showMore[agreement.code] && isAgreementTruncatable(agreement.content)"
                   role="button"
                   :aria-expanded="false"
                   :aria-controls="agreement.code + '_content'"
                   :ref="agreement.code + '_moreButton'"
                   @keydown.13.stop="toggleElement(agreement.code)"
                   @keydown.32.prevent
                   @keyup.32="toggleElement(agreement.code)"
                   @click.prevent="toggleElement(agreement.code)"
                   :title="$t('paywall.form.linkShowMoreTitle')">
                  {{ $t('paywall.form.linkMore') }}
                </a>
                <a class="show-more"
                   href=""
                   v-if="showMore[agreement.code]"
                   role="button"
                   :aria-expanded="true"
                   :aria-controls="agreement.code + '_content'"
                   :ref="agreement.code + '_lessButton'"
                   @keydown.13.stop="toggleElement(agreement.code)"
                   @keydown.32.prevent
                   @keyup.32="toggleElement(agreement.code)"
                   @click.prevent="toggleElement(agreement.code)"
                   :title="$t('paywall.form.linkShowLessTitle')">
                  {{ $t('paywall.form.linkLess') }}
                </a>
              </div>
            </div>
            <p role="alert" v-if="showTouchedError(agreement.code) || isErrorForField(agreement.code)" class="error"
               :id="getErrorId(agreement.code)"
               :aria-label="getFieldErrorAriaLabel(agreement.code, agreement.inputLabel)">
              <span aria-hidden="true">{{ getFieldErrorText(agreement.code) }}</span>
            </p>
          </div>
        </div>

        <!-- regulamin jako oświadczenie -->
        <div v-if="regulation && isRegulationHidden">
          <div class="form-row">
            <p class="elem-hidden-for-aria"
               v-html="$t('paywall.form.mwfClauseARIA', {regulationUrl: regulation.url, privacyPolicyUrl: privacyPolicyUrl})"></p>
            <p aria-hidden="true" class="terms-clause">
              <regulation-text v-if="isRegulationLabelSet(regulation)" :regulation="regulation"></regulation-text>
              <!-- TODO: określić co w przypadku jeśli regulamin nie ma labela -->
              <span v-if="!isRegulationLabelSet(regulation)"
                    v-html="$t('paywall.form.termsLabelDefault', {regulationUrl: regulation.url, privacyPolicyUrl: privacyPolicyUrl})"></span>
            </p>
          </div>
        </div>
      </div>

      <!-- FR warning -->
      <div class="fr-info-box" v-if="isPaywayGroupFr">
        <p>
          <strong>{{ $t('paywall.frInfo.paywall.text1') }}</strong>
          {{ $t('paywall.frInfo.paywall.text2') }}
        </p>
      </div>

      <!-- submit -->
      <div class="submit-wrapper" v-if="!isClick2PayOnlyView">
        <div>
          <button v-if="isPaywayWithStandardButton" class="btn" :class="{'inactive': !isAutoCard && isFormInvalid()}"
                  :disabled="isSubmitDisabled"
                  :aria-disabled="(!isAutoCard && isFormInvalid()) || isSubmitDisabled ? 'true' : undefined"
                  :aria-label="(!isAutoCard && isFormInvalid()) ? $t('paywall.form.submitButton.ariaLabelInactive') : undefined">
            <span>{{ getSubmitButtonText() }}</span>
          </button>
          <button v-if="isVisaMobilePay" class="btn visamobile" :class="{'inactive': isFormInvalid()}"
                  :disabled="isSubmitDisabled"
                  :aria-disabled="isFormInvalid() || isSubmitDisabled ? 'true' : undefined"
                  :aria-label="isFormInvalid() ? $t('paywall.form.submitButton.ariaLabelInactive') : undefined">
            <span>{{ $t('paywall.form.submitButton.visaMobile') }}</span>
          </button>
          <google-pay-payway :marketing="marketing" v-if="isGooglePay"></google-pay-payway>
          <apple-pay v-if="isApplePay" :marketing="marketing"></apple-pay>
          <visa-checkout-pay :marketing="marketing" v-if="isVisaCheckoutPay"></visa-checkout-pay>
        </div>
        <p v-if="canShowPaymentInfo()" v-html="$t('paywall.form.paymentInfo')"></p>
      </div>
    </form>
  </div>
</template>

<script>
import PaymentPaywayList from '@/base/components/Payment/Paywall/PaywayList'
import RegulationText from '@/base/components/Payment/Paywall/RegulationText.vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { PAYMENT_INIT_TYPE, PAYMENT_SERVICE_TYPE } from '@/base/const/payment.const'
import {
  AUTO_ID_LIST,
  CARD_ID_LIST,
  INSTALLMENT_TYPES, OTP_TYPES,
  PAYWAY_GROUPS_TYPES,
  VISA_MOBILE_TYPES,
  WALLET_TYPES,
  getRequiredParamLabel,
  getRequiredParamPlaceholder,
  getRequiredParamFlowLabel, getRequiredParamFieldType, isRequiredParamFieldTypeText, isRequiredParamFieldTypeCheckbox
} from '@/base/const/payway.const'
import { PAYWALL_MODE } from '@/base/const/paywall.const'
import { PaymentClass } from '@/base/class/payment.class'
import { ToolsClass } from '@/base/class/tools.class'
import {
  MATOMO_CUSTOM_DIMENSION,
  MATOMO_EVENT_CATEGORY,
  MATOMO_EVENT_TYPE,
  MATOMO_FORM_ACTION,
  MATOMO_PAYMENT_TYPE_GROUP,
  MATOMO_USER_TYPE,
  MATOMO_VALIDATION_ERROR_NAME
} from '@/base/const/matomo.const'
import { MatomoClass } from '@/base/class/matomo.class'
import { FormClass } from '@/base/class/form.class'
import GooglePayPayway from '@/base/components/Payment/Paywall/Wallet/GooglePay'
import ApplePay from '@/base/components/Payment/Paywall/Wallet/ApplePay'
import VisaCheckoutPay from '@/base/components/Payment/Paywall/Wallet/VisaCheckoutPay'
import { DateClass } from '@/base/class/date.class'
import FormMixin from '@/base/mixins/form.mixin'
import FormIframeCardsMixin from '@/base/mixins/formIframeCards.mixin'
import FormIframeVisaMobile from '@/base/mixins/formIframeVisaMobile.mixin'
import { REGULATION_TYPE } from '@/base/const/regulation.const'
import { ORANGE_CONTEXT_LIST } from '@/base/const/context.const'
import { CLICK2PAY_LOG_LEVEL, CLICK2PAY_VIEW } from '@/base/const/click2pay.const'
import ClickToPayLoginForm from '@/base/components/Payment/Paywall/ClickToPay/LoginForm.vue'
import ClickToPayCodeForm from '@/base/components/Payment/Paywall/ClickToPay/CodeForm.vue'
import ClickToPayCardSelected from '@/base/components/Payment/Paywall/ClickToPay/CardSelected.vue'
import ClickToPayCardSelect from '@/base/components/Payment/Paywall/ClickToPay/CardSelect.vue'
import ClickToPayNewUser from '@/base/components/Payment/Paywall/ClickToPay/NewUser.vue'
import ClickToPayProfile from '@/base/components/Payment/Paywall/ClickToPay/Profile.vue'
import { LANGUAGES_CODE_LIST } from '@/base/const/lang.const'
import { CARD_ISSUERS } from '@/base/const/cards.const'
import { BLIK_MODEL } from '@/base/const/blik.const'
import { PAYPAL_COUNTRY_CODES } from '@/base/const/countryCodes.const'
import { FUSE_OPTIONS, FUSE_VALID_EMAIL_DOMAINS_LIST } from '@/base/const/validators.const'
import Fuse from 'fuse.js'
import { CookieClass } from '@/base/class/cookie.class'
import { COOKIE_GCID } from '@/base/const/cookies.const'
import { apiClass } from '@/base/class/api.class'
import { ENDPOINTS } from '@/base/const/endpoints.const'

export default {
  name: 'PaywallForm',
  components: {
    ClickToPayProfile,
    ClickToPayNewUser,
    ClickToPayCardSelect,
    ClickToPayCardSelected,
    ClickToPayCodeForm,
    ClickToPayLoginForm,
    VisaCheckoutPay,
    ApplePay,
    GooglePayPayway,
    PaymentPaywayList,
    RegulationText
  },
  mixins: [
    FormMixin,
    FormIframeCardsMixin,
    FormIframeVisaMobile
  ],
  data () {
    return {
      paywayRequiredParamsList: [],
      requiredParams: {},
      marketing: {},
      widget: null,
      visaMobile: null,
      creditCard: null,
      isCreditCardMastercard: false,
      isCreditCardVisa: false,
      iframeLoaded: false,
      showMore: {},
      showReccuringTermsMore: false,
      showMwfTermsMore: false,
      showClick2PayPaymentIframe: false,
      showEmailFuseInfo: false,
      dccData: null,
      c2p: {
        saveCard: false,
        dccChecked: false
      },
      fuse: {
        checked: false,
        confirmed: false
      }
    }
  },
  watch: {
    selectedCard: function (value) {
      if (typeof value === 'object') {
        this.creditCard = true
      } else {
        this.creditCard = null
      }
    },
    isClick2PayAvailable: function (value, oldValue) {
      if (value && value !== oldValue) {
        this.initC2PIdentityLookup()
      }
    },
    activePayway: function (value, oldValue) {
      if (value && value !== oldValue) {
        this.generatePaywayRequiredParamsList()
      }
    },
    customerEmail: ToolsClass.debounce(function (value, oldValue) {
      if (value !== oldValue && String(value).length > 0) {
        this.checkFuseForEmail(value)
      }
    }, 1000),
    blikCode (val) {
      if (val && val.replace(/\D/g, '').length === 6) {
        MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.form, MATOMO_FORM_ACTION.blikFilled])
      }
    },
    regulationApproved (val, oldVal) {
      if (val === oldVal) return
      const action = val ? MATOMO_FORM_ACTION.regulationChecked : MATOMO_FORM_ACTION.regulationUnchecked
      MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.form, action])
    },
    marketing: {
      deep: true,
      handler (val) {
        Object.keys(val).forEach(code => {
          const prev = this._matomoMarketing[code]
          const curr = val[code]
          if (prev !== curr) {
            const action = curr ? MATOMO_FORM_ACTION.agreementChecked : MATOMO_FORM_ACTION.agreementUnchecked
            MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.form, action, code])
          }
        })
        this._matomoMarketing = { ...val }
      }
    }
  },
  props: {
    paywayGroup: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getCurrentLanguage',
      paywayList: 'getPaywayList',
      marketingAgreementList: 'getMarketingAgreementList',
      visaProfileCorrelationId: 'getC2PVisaCorrelationId'
    }),
    ...mapState({
      language: state => state.lang.current,
      isClick2PayAvailable: state => state.c2p.isProcessAvailable,
      isClick2PayMastercardAvailable: state => state.c2pMastercard.isProcessAvailable,
      isClick2PayVisaAvailable: state => state.c2pVisa.isProcessAvailable,
      isClick2PayLoading: state => state.c2p.loading,
      selectedCard: state => state.c2p.selectedCard,
      click2PayData: state => state.c2p.initData,
      checkoutProvider: state => state.c2p.checkoutProvider,
      isProcessing: state => state.payment.processing,
      showEmail: state => state.payment.paymentData.visibilityOptions
        ? state.payment.paymentData.visibilityOptions.showFrontEmail
        : null,
      isInitialCustomerEmailSet: state => state.payment.paymentData.additionalData && state.payment.paymentData.additionalData.customerEmail
        ? !!state.payment.paymentData.additionalData.customerEmail.length
        : false,
      showReturnToPaywaysButton: state => state.payment.paymentData.visibilityOptions
        ? state.payment.paymentData.visibilityOptions.showReturnToPaywaysButton
        : null,
      showReturnToShopButton: state => state.payment.paymentData.visibilityOptions
        ? state.payment.paymentData.visibilityOptions.showReturnToShopButton
        : null,
      isAutoCard: state => AUTO_ID_LIST.includes(state.payment.form.paywayID),
      isCard: state => CARD_ID_LIST.includes(state.payment.form.paywayID),
      isVisaMobilePay: state => state.payment.form.paywayID === VISA_MOBILE_TYPES.visaMobile.id,
      isVisaCheckoutPay: state => state.payment.form.paywayID === WALLET_TYPES.visaCheckout.id,
      isGooglePay: state => state.payment.form.paywayID === WALLET_TYPES.googlePay.id,
      isApplePay: state => state.payment.form.paywayID === WALLET_TYPES.applePay.id,
      regulation: state => state.payment.form.regulation,
      isPbl: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.pbl,
      isWallet: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.wallet,
      isOtp: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.otp,
      isOtpBlikPayLaterSelected: state => state.payment.form.paywayID === OTP_TYPES.blikPayLater.id,
      isOtpPaykaSelected: state => state.payment.form.paywayID === OTP_TYPES.payka.id,
      isInstallments: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.installments,
      isInstallmentsSelected: state => state.payment.form.paywayID === INSTALLMENT_TYPES.alior.id,
      isAutoGroup: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.auto,
      isBlikAutoGroup: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.blikAuto,
      isBlikPayLaterGroup: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.blikPayLater,
      isFastTransfer: state => state.payment.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.transfer,
      transaction: state => state.payment.paymentData.transaction,
      isServiceTypeEcommerce: state => state.payment.paymentData.serviceType === PAYMENT_SERVICE_TYPE.ecommerce,
      isServiceTypeMwf: state => state.payment.paymentData.serviceType === PAYMENT_SERVICE_TYPE.mwf,
      serviceType: state => state.payment.paymentData.serviceType,
      serviceID: state => state.payment.paymentData.serviceID,
      amount: state => state.payment.paymentData.payAmount,
      currency: state => state.payment.paymentData.payAmountCurrency,
      isCardRecurringRegulationToShow: state => state.payment.paymentData.isCardRecurringRegulationToShow,
      recurringAction: state => state.payment.paymentData.recurringAction,
      selectedPaywayGroupType: state => state.payment.selectedPaywayGroupType,
      isPaywallModeChosenPayway: state => state.payment.paywallMode === PAYWALL_MODE.chosenPayway,
      merchantShortName: state => state.payment.paymentData.shortName,
      idTransRemote: state => state.payment.paymentData.transRemoteID,
      orderId: state => state.payment.paymentData.transaction.orderId,
      paywallStartTime: state => state.timer.paywallView,
      paymentToken: state => state.payment.paymentData.paymentToken,
      click2PayProcessActive: state => state.c2p.isProcessActive,
      click2PayView: state => state.c2p.view,
      paywaysLanguageData: function (state) {
        return state.payment.paywaysLanguageData !== null ? state.payment.paywaysLanguageData[this.paywayID] : null
      }
    }),
    isClick2PayProcessActive: function () {
      return this.click2PayProcessActive
    },
    isClick2PayViewNotRecognized: function () {
      return this.click2PayView === CLICK2PAY_VIEW.notRecognized
    },
    isClick2PayViewLoginForm: function () {
      return this.click2PayView === CLICK2PAY_VIEW.loginForm
    },
    isClick2PayViewCodeForm: function () {
      return this.click2PayView === CLICK2PAY_VIEW.codeForm
    },
    isClick2PayViewCardSelected: function () {
      return this.click2PayView === CLICK2PAY_VIEW.cardSelected
    },
    isClick2PayViewCardSelect: function () {
      return this.click2PayView === CLICK2PAY_VIEW.cardSelect
    },
    isClick2PayViewNewCard: function () {
      return this.click2PayView === CLICK2PAY_VIEW.newCard
    },
    isClick2PayViewDcc: function () {
      return this.click2PayView === CLICK2PAY_VIEW.dcc
    },
    isClick2PayViewNewUser: function () {
      return this.click2PayView === CLICK2PAY_VIEW.newUser
    },
    isClick2PayOnlyView: function () {
      if (!this.isCard) {
        return false
      }
      const click2payInnerViews = [
        CLICK2PAY_VIEW.newUser,
        CLICK2PAY_VIEW.cardSelect,
        CLICK2PAY_VIEW.loginForm,
        CLICK2PAY_VIEW.codeForm
      ]
      return click2payInnerViews.includes(this.click2PayView)
    },
    activePayway: function () {
      if (!this.paywayID) {
        return null
      }
      return this.paywayList.find(payway => payway.id === this.paywayID)
    },
    privacyPolicyUrl: function () {
      return PaymentClass.getPrivacyPolicyLinkByLang(this.lang)
    },
    isRegulationHidden: function () {
      if (!this.regulation) {
        return true
      }
      return this.regulation.checkedAndHidden
    },
    isRegulationReccuring: function () {
      return this.regulation && this.regulation.type === REGULATION_TYPE.recurring
    },
    isPaywayTypePis: function () {
      return PaymentClass.isPaywayTypePis(this.paywayID, this.paywayList)
    },
    isPaywayWithStandardButton: function () {
      return !this.isGooglePay && !this.isApplePay && !this.isVisaMobilePay && !this.isVisaCheckoutPay
    },
    canShowMarketingAgreementList: function () {
      return !(this.$VUE_HIDE_MARKETING && this.$VUE_HIDE_MARKETING === true) && this.marketingAgreementList.length > 0
    },
    canShowAgreementHeader: function () {
      if (this.isRegulationHidden) {
        return this.canShowMarketingAgreementList
      }
      return !!this.regulation || this.canShowMarketingAgreementList
    },
    canShowCheckAll: function () {
      if (this.isRegulationHidden) {
        return this.canShowMarketingAgreementList
      }
      return !!this.regulation || this.canShowMarketingAgreementList
    },
    isCardIframeHidden: function () {
      if (!this.isCard) {
        return false
      }
      return !(this.isClick2PayViewNotRecognized || this.isClick2PayViewNewCard || this.isClick2PayViewDcc)
    },
    canShowClick2PayProfileInfo: function () {
      return this.isClick2PayViewNotRecognized ||
        this.isClick2PayViewNewCard ||
        this.isClick2PayViewCardSelected ||
        this.isClick2PayViewDcc ||
        this.isClick2PayViewLoginForm
    },
    canShowCardsIframe: function () {
      return this.activePayway && !this.activePayway.redirectToCards
    },
    isVisaMobile: function () {
      return this.paywayID === VISA_MOBILE_TYPES.visaMobile.id
    },
    isPaywayGroupFr: function () {
      return this.paywayGroup.type === PAYWAY_GROUPS_TYPES.transfer
    },
    isSubmitDisabled: function () {
      return this.isProcessing || ((this.isCard || this.isVisaMobilePay) && !this.iframeLoaded)
    },
    hasPaywayRequiredFields: function () {
      return this.activePayway?.requiredParams?.length > 0
    },
    isBlikModel0: function () {
      if (!this.activePayway) {
        return false
      }
      return this.activePayway.additionalData?.blikModel === BLIK_MODEL.model0
    },
    isBlikModelM: function () {
      if (!this.activePayway) {
        return false
      }
      return this.activePayway.additionalData?.blikModel === BLIK_MODEL.modelM
    },
    paywayID: {
      get () {
        return this.$store.state.payment.form.paywayID
      },
      set () {
      }
    },
    regulationApproved: {
      get () {
        return this.$store.state.payment.form.regulationApproved
      },
      set (value) {
        if (value) {
          this.SET_PAYMENT_FORM_REGULATION_APPROVED(true)
          if (this.isRegulationReccuring) {
            this.SET_PAYMENT_FORM_RECURRING_ACCEPTANCE_STATE_AFTER('ACCEPTED')
          }
        } else {
          this.SET_PAYMENT_FORM_REGULATION_APPROVED(false)
          this.SET_PAYMENT_FORM_RECURRING_ACCEPTANCE_STATE_AFTER(null)
        }
      }
    },
    checkAll: {
      get () {
        const flags = []
        if (!this.isRegulationHidden && this.regulation) {
          flags.push(!!this.$store.state.payment.form.regulationApproved)
        }
        Object.keys(this.marketing).forEach(key => {
          flags.push(!!this.marketing[key])
        })
        return flags.reduce((acc, value) => {
          return acc && value
        }, true)
      },
      set (value) {
        if (!this.isRegulationHidden && this.regulation) {
          if (value) {
            this.SET_PAYMENT_FORM_REGULATION_APPROVED(true)
            if (this.isRegulationReccuring) {
              this.SET_PAYMENT_FORM_RECURRING_ACCEPTANCE_STATE_AFTER('ACCEPTED')
            }
          } else {
            this.SET_PAYMENT_FORM_REGULATION_APPROVED(false)
            this.SET_PAYMENT_FORM_RECURRING_ACCEPTANCE_STATE_AFTER(null)
          }
        }
        Object.keys(this.marketing).forEach(key => {
          this.marketing[key] = value
        })
      }
    },
    customerEmail: {
      get () {
        return this.$store.state.payment.form.customerEmail
      },
      set (value) {
        this.SET_PAYMENT_FORM_EMAIL(value)
      }
    },
    blikCode: {
      get () {
        return this.$store.state.payment.form.blikCode
      },
      set (value) {
        this.SET_PAYMENT_FORM_BLIK_CODE(value)
      }
    },
    paypalCountryCodes: function () {
      return PAYPAL_COUNTRY_CODES
    }
  },
  methods: {
    isRequiredParamFieldTypeCheckbox,
    isRequiredParamFieldTypeText,
    getRequiredParamFieldType,
    getRequiredParamFlowLabel,
    getRequiredParamLabel,
    getRequiredParamPlaceholder,
    ...mapMutations([
      'SET_PAYMENT_LOADING',
      'SET_PAYMENT_FORM_EMAIL',
      'SET_PAYMENT_FORM_BLIK_CODE',
      'SET_PAYMENT_FORM_REGULATION_APPROVED',
      'SET_PAYMENT_FORM_RECURRING_ACCEPTANCE_STATE_AFTER',
      'SET_PAYMENT_FORM_WALLET_TYPE',
      'SET_ERROR_DATA',
      'SET_TIMER_FORM_SUBMITED',
      'SET_TIMER_TRX_UPDATE_START',
      'SET_TIMER_TRX_UPDATE_LOADED',
      'SET_C2P_LOADING',
      'SET_C2P_VIEW',
      'SET_C2P_TRANSACTION_AMOUNT',
      'SET_C2P_TRANSACTION_CURRENCY',
      'SET_C2P_IS_PROCESS_AVAILABLE',
      'SET_C2P_PROCESS_RESET',
      'SET_C2P_ENCRYPTED_CARD',
      'SET_C2P_CHECKOUT_PROVIDER'
    ]),
    ...mapActions([
      'sendPaymentUpdateTrx',
      'logTimerStats',
      'changePaywallMode',
      'disableSessionTimer',
      'getClick2PayEnrollCard',
      'getC2PCheckout',
      'getC2PIdentityLookup',
      'logC2PTransaction'
    ]),
    generatePaywayRequiredParamsList () {
      this.paywayRequiredParamsList = []
      this.requiredParams = {}
      if (!this.activePayway || !this.activePayway.requiredParams || !this.activePayway.requiredParams.length) {
        return
      }

      const fieldsList = []
      this.activePayway.requiredParams.forEach(param => {
        switch (param.name) {
          case 'customerEmail':
            if (!this.showEmail) {
              fieldsList.push(param)
              this.requiredParams[param.name] = ''
            }
            break
          case 'shippingCountryCode':
            fieldsList.push(param)
            this.requiredParams[param.name] = ''
            break
          default:
            fieldsList.push(param)
            this.requiredParams[param.name] = ''
        }
      })
      if (fieldsList.length) {
        const fieldsListSorted = ToolsClass.sortArrayByObjectProperty(fieldsList, 'order')
        const grouppedFields = {
          ungrupped: []
        }
        fieldsListSorted.map(field => {
          if (field.group) {
            if (!grouppedFields[field.group]) {
              grouppedFields[field.group] = []
            }
            grouppedFields[field.group].push(field)
          } else {
            grouppedFields.ungrupped.push(field)
          }
        })
        this.paywayRequiredParamsList = grouppedFields
      }
    },
    getPaypalCountryName (country) {
      if (country.names[this.lang] && country.names[this.lang].length > 0) {
        return country.names[this.lang]
      }
      return country.names['EN']
    },
    goToClick2PayCardSelected () {
      this.SET_C2P_VIEW(CLICK2PAY_VIEW.cardSelected)
    },
    goToClick2PayNewUser () {
      this.SET_C2P_VIEW(CLICK2PAY_VIEW.newUser)
    },
    goToClick2PayDcc () {
      this.SET_C2P_VIEW(CLICK2PAY_VIEW.dcc)
    },
    isRegulationLabelSet (regulation) {
      return !!regulation.inputLabel && String(regulation.inputLabel).length
    },
    toggleRegulationByContentClick (event) {
      if (this.triggerRelatedCheckboxClick(event)) {
        return
      }
      this.regulationApproved = !this.regulationApproved
    },
    toggleAgreementByContentClick (agreement, event) {
      if (this.triggerRelatedCheckboxClick(event)) {
        return
      }
      this.marketing[agreement.code] = !this.marketing[agreement.code]
    },
    showAliorModal (event) {
      event.preventDefault()
      const message = {
        focusReturnElementId: 'aliorHelp',
        component: 'AliorModal',
        options: {
          size: 'big',
          hideButton: true,
          showClose: true
        }
      }
      this.addModalInfo(message)
    },
    showPaykaModal (event) {
      event.preventDefault()
      const message = {
        focusReturnElementId: 'paykaHelp',
        component: 'PaykaModal',
        options: {
          size: 'big',
          hideButton: true,
          showClose: true
        }
      }
      this.addModalInfo(message)
    },
    showClick2PayModal (event) {
      event.preventDefault()
      const message = {
        focusReturnElementId: 'click2payHelp',
        component: 'Click2PayModal',
        options: {
          size: 'medium',
          hideButton: true,
          showClose: true
        }
      }
      this.addModalInfo(message)
    },
    showClick2PayProcessErrorModal () {
      const message = {
        focusReturnElementId: 'paywayID',
        component: 'Click2PayPrcessErrorModal',
        options: {
          size: 'medium',
          hideButton: false,
          showClose: true
        }
      }
      this.addModalInfo(message)
    },
    isFormInvalid () {
      if (this.form) {
        return this.form.invalid
      }
      return false
    },
    toggleElement (name) {
      const elementValue = !!this.showMore[name]
      this.showMore[name] = !elementValue
      this.$forceUpdate()
      if (!elementValue) {
        this.$nextTick(() => {
          this.$refs[name + '_lessButton'][0].focus()
        })
      } else {
        this.$nextTick(() => {
          this.$refs[name + '_moreButton'][0].focus()
        })
      }
    },
    canShowPaywayList () {
      return (this.isPbl || this.isWallet || this.isFastTransfer || this.isAutoGroup || this.isOtp || this.isInstallments) && !AUTO_ID_LIST.includes(this.paywayID)
    },
    canShowPaymentInfo () {
      return this.isPbl
    },
    changeTransactionDataByDcc (dccData) {
      this.SET_C2P_TRANSACTION_AMOUNT(dccData.amount)
      this.SET_C2P_TRANSACTION_CURRENCY(dccData.currency)
      this.dccData = dccData
    },
    submitClick2PayEncryptedCard (encryptedCard) {
      this.SET_C2P_ENCRYPTED_CARD(encryptedCard)
      if (this.isCreditCardMastercard) {
        this.SET_C2P_CHECKOUT_PROVIDER(CARD_ISSUERS.mastercard)
      }
      if (this.isCreditCardVisa) {
        this.SET_C2P_CHECKOUT_PROVIDER(CARD_ISSUERS.visa)
      }
      if (!this.click2PayProcessActive || this.isCreditCardVisa) {
        this.goToClick2PayNewUser()
      } else {
        this.widget && this.submitClick2PayCheckout()
      }
    },
    resetForm () {
      this.form.resetForm()
      this.c2p.saveCard = false
      this.c2p.dccChecked = false
    },
    resetCardWidget () {
      setTimeout(() => {
        this.widget && this.widget.reset()
        this.creditCard = null
        this.resetForm()
        this.c2p.saveCard = false
        this.c2p.dccChecked = false
      }, 50)
    },
    resetClick2PayProcess () {
      this.resetCardWidget()
      this.showClick2PayProcessErrorModal()
      this.SET_C2P_IS_PROCESS_AVAILABLE(false)
      this.SET_C2P_PROCESS_RESET()
      this.SET_C2P_VIEW(CLICK2PAY_VIEW.notRecognized)
    },
    cancelClick2PayProcess () {
      this.widget && this.widget.resetCheckoutProcess()
      this.c2p.saveCard = false
      this.submit()
    },
    resolveCheckDccForSelectedCard (response) {
      this.c2p.dccChecked = true
      if (response === 'DCC') {
        this.goToClick2PayDcc()
        ToolsClass.scrollToElementTop(document.querySelector('header'))
        return
      }
      this.submitClick2PayCheckout()
    },
    submitClick2PayCheckout () {
      ToolsClass.scrollToElementTop(document.querySelector('header'))
      this.showClick2PayPaymentIframe = true
      this.getC2PCheckout(LANGUAGES_CODE_LIST[this.language])
        .then(response => {
          const data = {
            digitalCardId: '',
            correlationId: '',
            dpaId: '',
            transactionId: this.click2PayData.srciTransactionId,
            organization: this.checkoutProvider,
            checkoutResponse: '',
            dccState: this.dccData ? this.dccData.dccState : '',
            dccRequestUuid: this.dccData ? this.dccData.dccRequestUuid : ''
          }
          if (this.checkoutProvider === CARD_ISSUERS.mastercard) {
            data.dpaId = this.click2PayData.mastercard.srciDpaId ? this.click2PayData.mastercard.srciDpaId : this.click2PayData.srciDpaId
            data.digitalCardId = response.checkoutResult.checkoutResponse.maskedCard.srcDigitalCardId
            data.correlationId = response.checkoutResult.checkoutResponse.srcCorrelationId
          }
          if (this.checkoutProvider === CARD_ISSUERS.visa) {
            data.dpaId = this.click2PayData.visa.srciDpaId
            data.checkoutResponse = response.checkoutResult.checkoutResponse
            data.correlationId = this.visaProfileCorrelationId
          }
          this.widget && this.widget.sendCheckout(data)
        })
        .catch(error => {
          this.logC2PTransaction({
            context: 'C2P submitClick2PayCheckout',
            message: error,
            logLevel: CLICK2PAY_LOG_LEVEL.error,
            isFatal: true,
            organization: this.checkoutProvider
          })
          this.showClick2PayPaymentIframe = false
          this.resetClick2PayProcess()
        })
    },
    supportSyncHubCookie () {
      const isAnyMarketingAgree = Object.values(this.marketing).some(value => value === true)
      if (!isAnyMarketingAgree) {
        return
      }
      const cookieGcid = CookieClass.getCookie(COOKIE_GCID)
      const gcid = cookieGcid ? String(cookieGcid) : ToolsClass.generateULID()
      CookieClass.setCookie(COOKIE_GCID, gcid, 365, '.autopay.eu')
      apiClass.postSyncHub(ENDPOINTS.synchub.cookieLink, {
        scid: '',
        gcid: String(gcid),
        adform: '',
        email: String(this.customerEmail)
      }).catch(() => {
      })
    },
    onEmailBlur () {
      const field = FormClass.findFieldControl('customerEmail', this.form)
      if (field && !field.invalid && this.customerEmail) {
        MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.form, MATOMO_FORM_ACTION.emailFilled])
      }
    },
    submit (e, token, forceVisaMobile = false) {
      if (!forceVisaMobile) {
        if (this.isSubmitDisabled) {
          return
        }
        if (this.form.invalid) {
          this.scrollToError()
          const groupType = MATOMO_PAYMENT_TYPE_GROUP[this.selectedPaywayGroupType]
          ;['paywayID', 'customerEmail', 'regulationApproved', 'blikCode'].forEach(fieldName => {
            const field = FormClass.findFieldControl(fieldName, this.form)
            if (field && field.invalid && MATOMO_VALIDATION_ERROR_NAME[fieldName]) {
              MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.validationError, groupType, MATOMO_VALIDATION_ERROR_NAME[fieldName]])
            }
          })
          return
        }
      }

      if (this.isCard) {
        ToolsClass.scrollToElementTop(document.querySelector('iframe'), -50)
        if (!token) {
          // użycie zapisanej w C2P karty
          if (this.isClick2PayProcessActive && this.selectedCard) {
            this.submitClick2PayCheckout()
          } else {
            if (!this.c2p.saveCard) {
              this.widget && this.widget.sendForm()
            } else {
              this.widget && this.widget.encryptCard()
            }
          }
          return
        }
      }

      if (this.isAutoCard && !this.activePayway.redirectToCards) {
        ToolsClass.scrollToElementTop(document.querySelector('iframe'), -50)
        if (!token) {
          this.widget && this.widget.sendForm()
          return
        }
      }

      if (this.isVisaMobile) {
        ToolsClass.scrollToElementTop(document.querySelector('iframe'), -50)
        if (!token) {
          this.visaWidget && this.visaWidget.sendForm()
          return
        }
      }

      ToolsClass.scrollToElementTop(document.querySelector('header'))
      this.SET_TIMER_FORM_SUBMITED(DateClass.getCurrentTimestamp())

      if (this.isCard || this.isAutoCard) {
        this.SET_PAYMENT_FORM_WALLET_TYPE('WIDGET')
      } else {
        this.SET_PAYMENT_FORM_WALLET_TYPE(null)
      }

      MatomoClass.sendCustomDimension(MATOMO_CUSTOM_DIMENSION.sid, this.serviceID)
      MatomoClass.sendCustomDimension(MATOMO_CUSTOM_DIMENSION.paymentTypeGroup, MATOMO_PAYMENT_TYPE_GROUP[this.selectedPaywayGroupType])
      MatomoClass.sendCustomDimension(MATOMO_CUSTOM_DIMENSION.paymentTypeChannel, this.paywayID)
      MatomoClass.sendCustomDimension(MATOMO_CUSTOM_DIMENSION.userType, MATOMO_USER_TYPE.direct)

      // Matomo event
      const event = [
        MATOMO_EVENT_TYPE.trackEcommerceOrder,
        this.transaction.orderId,
        this.transaction.payAmount
      ]
      MatomoClass.sendEvent(event)

      // SyncHub cookie
      this.supportSyncHubCookie()

      this.disableSessionTimer()
      this.SET_TIMER_TRX_UPDATE_START(DateClass.getCurrentTimestamp())
      const data = {
        paymentToken: token,
        marketing: this.marketing,
        requiredParams: this.requiredParams
      }
      this.sendPaymentUpdateTrx(data).finally(() => {
        this.SET_TIMER_TRX_UPDATE_LOADED(DateClass.getCurrentTimestamp())
        this.logTimerStats()
      }).catch(error => {
        this.SET_ERROR_DATA({
          errorCode: error.body.errorCode,
          errorUrl: error.body.errorUrl
        })
      })
    },
    sendToken (token) {
      this.submit(null, token)
    },
    getSubmitButtonText () {
      if (this.activePayway && this.paywaysLanguageData && this.paywaysLanguageData?.buttonTitle && this.paywaysLanguageData?.buttonTitle.length > 0) {
        return this.paywaysLanguageData.buttonTitle
      }
      if (this.c2p.saveCard) {
        if (this.isServiceTypeMwf) {
          return this.$t('paywall.form.submitButton.c2pAccept')
        }
        if (this.isClick2PayProcessActive) {
          return this.$t('paywall.form.submitButton.c2pSaveAndPay')
        }
        return this.$t('paywall.form.submitButton.c2pNext')
      }
      if (this.isAutoCard) {
        if (ORANGE_CONTEXT_LIST.includes(this.$VUE_CONTEXT_NAME)) {
          return this.$t('paywall.form.submitButton.orange')
        }
        if ([PAYMENT_INIT_TYPE.initWithRefund, PAYMENT_INIT_TYPE.initWithPayment].includes(this.recurringAction)) {
          if (this.isServiceTypeMwf && !this.activePayway.redirectToCards) {
            return this.$t('paywall.form.submitButton.mwf')
          }
          return this.$t('paywall.form.submitButton.autoPayment')
        }
        if (this.isServiceTypeMwf && !this.activePayway.redirectToCards) {
          return this.$t('paywall.form.submitButton.mwf')
        }
        return this.$t('paywall.form.submitButton.auto')
      }
      if (this.isFastTransfer) {
        return this.$t('paywall.form.submitButton.fastTransfer')
      }
      if (this.isPaywayTypePis) {
        return this.$t('paywall.form.submitButton.pis')
      }
      if (this.isServiceTypeMwf) {
        return this.$t('paywall.form.submitButton.mwf')
      }
      return this.$t('paywall.form.submitButton.other')
    },
    setPaywallModeDefault () {
      this.changePaywallMode(PAYWALL_MODE.main)
    },
    initC2PIdentityLookup () {
      if (this.canShowCardsIframe && this.isCard && (this.customerEmail && this.customerEmail.length > 0) && this.isClick2PayAvailable) {
        if (!this.click2PayProcessActive) {
          this.SET_C2P_LOADING(true)
          this.getC2PIdentityLookup().catch(error => {
            this.logC2PTransaction({
              context: 'C2P getC2PIdentityLookup',
              message: error,
              logLevel: CLICK2PAY_LOG_LEVEL.error,
              isFatal: true,
              organization: this.checkoutProvider
            })
            this.showClick2PayPaymentIframe = false
            this.resetClick2PayProcess()
          })
        }
        if (this.click2PayProcessActive) {
          this.creditCard = !!this.selectedCard
        }
      }
    },
    getAgreementShortText (content) {
      const maxLength = 12
      if (!content) return ''
      const plainText = ToolsClass.stripHtmlTags(content)
      const words = plainText.trim().split(/\s+/)
      if (words.length <= maxLength) return plainText
      return words.slice(0, maxLength).join(' ') + '...'
    },
    isAgreementTruncatable (content) {
      const maxLength = 10
      if (!content) return false
      const plainText = ToolsClass.stripHtmlTags(content)
      return plainText.trim().split(/\s+/).length > maxLength
    },
    checkFuseForEmail (email) {
      this.showEmailFuseInfo = false
      const emailParts = email.split('@')
      if (emailParts.length !== 2) {
        return
      }
      const domain = emailParts[1]
      if (!String(domain).length) {
        return
      }
      const fuse = new Fuse(FUSE_VALID_EMAIL_DOMAINS_LIST, FUSE_OPTIONS)
      const fuseResult = fuse.search(domain)
      if (fuseResult.length > 0) {
        // Jeśli znaleziono bliskie dopasowanie, ale różniące się od wpisanej domeny
        if (fuseResult[0].score > 0 && fuseResult[0].item !== domain) {
          this.showEmailFuseInfo = true
        }
      }
    }
  },
  mounted () {
    this.marketingAgreementList.forEach(agreement => {
      this.$set(this.marketing, agreement.code, false)
      this.$set(this.showMore, agreement.code, false)
    })
    this._matomoMarketing = { ...this.marketing }
    if (this.isVisaMobilePay && this.paymentToken && this.paymentToken.length) {
      this.submit(null, this.paymentToken, true)
    }
    this.initC2PIdentityLookup()
    this.generatePaywayRequiredParamsList()
    this.checkFuseForEmail(this.customerEmail)
  }
}
</script>

<style lang="scss" scoped>
@import "./src/base/assets/scss/variables.scss";
@import "./src/base/assets/scss/mixins.scss";
@import "./src/base/assets/scss/components/PaywallForm.scss";

.elem-hidden-for-aria {
  font-size: 0;
  line-height: 0;
  background-color: transparent;

  a.form-text-link {
    color: transparent;
    padding: 0;
  }
}

iframe {
  min-height: 450px;
  border: none;
  width: 100%;

  @include md {
    min-height: 309px;
  }

  &.hidden {
    display: none;
  }
}

.c2p-wrapper {
  position: relative;
  min-height: 140px;

  .c2p-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      width: 150px;
    }

    div {
      font-size: 1.4rem;
      text-align: center;
      padding-bottom: 40px;
    }
  }

  .click2payIframeWrapper {
    display: none;
  }

  &.with-c2p-iframe {
    height: 770px;
    padding-bottom: 20px;

    .click2payIframeWrapper {
      display: block;
      position: absolute;
      z-index: 100;
      width: 100%;
      height: 770px;
      background-color: #ffffff;

      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.agreements .form-row .agreement-label {
  font-size: 1.4rem;
  padding-bottom: 0;
  cursor: pointer;
}
</style>
